import React from 'react';
export function EditorContentIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.202 4.796L19.79 3.38a2.978 2.978 0 00-2.12-.88 2.98 2.98 0 00-2.118.873L4.217 14.669a1 1 0 00-.227.375c-.01.029-.026.055-.034.085l-1.426 5.66a1 1 0 001.211 1.215l5.66-1.406c.032-.008.061-.026.093-.037a1 1 0 00.367-.223l11.331-11.3a3 3 0 00.01-4.242zM5.462 17.335l1.661 1.667.081.08-2.328.578.585-2.325zm3.7.878L6.336 15.38l8.5-8.472 2.824 2.832-8.5 8.473zM19.783 7.622l-.709.706-2.824-2.833.708-.706a1 1 0 011.412.003l1.42 1.416a1 1 0 01-.007 1.414z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 4a1 1 0 011-1h9a1 1 0 110 2H3a1 1 0 01-1-1zm0 4a1 1 0 011-1h5a1 1 0 010 2H3a1 1 0 01-1-1zm0 4a1 1 0 011-1h1a1 1 0 110 2H3a1 1 0 01-1-1z"
  }));
}